// removed by extract-text-webpack-plugin
module.exports = {"loader":"styles-module__loader___1Azyf","spin":"styles-module__spin___1qu47"};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/Loader/styles.module.css
// module id = 1087
// module chunks = 0